import axios from 'axios';

const updateStandardAmount = function (target) {
  const row = $(target).closest('tr');
  const standardAmount = row.find('.workstation_order_standard_amount');
  const standardAmountHidden = row.find(
    '.workstation_order_standard_amount_hidden_field'
  );
  const ingredientId = row.find('.workstation_order_ingredient_select').val();
  const recipeId = $('#workstation_orders_form_recipe_id').text();

  axios
    .get('/ingredient_amount_by_recipe', {
      params: { recipe_id: Number(recipeId), ingredient_id: ingredientId },
    })
    .then(response => {
      standardAmount.text(response.data);
      standardAmountHidden.val(response.data);
    })
    .catch(error => {
      console.log(error.response.data);
    });
};

document.addEventListener('turbolinks:load', function () {
  // Update standard amount when the ingredient is changed
  $('.workstation_order_ingredient_select').on('change', function (e) {
    const target = $(e.currentTarget);
    updateStandardAmount(target);
  });

  $('#workstation_order_ingredients_table').on('cocoon:after-insert', () => {
    //  Initialize select2 after insert
    $('select').select2({
      width: '100%',
    });
    // Update standard amount when the ingredient is changed
    $('.workstation_order_ingredient_select').on('change', function (e) {
      const target = $(e.currentTarget);
      updateStandardAmount(target);
    });
  });
});
